<template>
  <div class="inventory--alternative-tab">
    <b-row class="alternative-grid-header">
      <b-col cols="12">
        <div class="pull-right tools">
          <!-- <b-button @click="showAddModal" ref="btnShow" size="sm" variant="primary">
            <i class="fa fa-plus" aria-hidden="true"></i>
            Add New Alternatives
          </b-button> -->
          <add-record
            v-if="checkClaim(CAN_ADD_INVENTORY)"
            :title="'Search and add alternatives'"
            :modalId="modalId"
            :gridId="addAlternativeGridId"
            :fields="addAlternativeFields"
            :resetModal="resetModal"
            :getListOfNames="onSearch"
            :saveRecord="addAlternatives"
            :items="alternativesParts"
            :showFilters="showFilters"
            :filterValObj="filterValObj"
            @updateCheckedRowItemIds="checkedAlternativePartIds = $event"
            class="mr-2">
            <template v-slot:headerSlot>
              <h6>Search existing alternatives in the field below or "Add New" alternative parts</h6>
            </template>
            <template v-slot:moreFilters>
              <b-button size="sm" variant="primary" @click="$bvModal.show('add-new-part-alternative')">Add New Part</b-button>
              <b-modal id="add-new-part-alternative" size="xl" ok-title="Save" scrollable hide-footer>
                <part-form propForm="alternative" @cancel="$bvModal.hide('add-new-part-alternative')" @partCreated="onPartCreated" />
              </b-modal>
            </template>
          </add-record>
          <b-button
            v-if="checkClaim(CAN_ADD_INVENTORY) && !hideUseThis"
            size="sm"
            variant="primary"
            :disabled="!selectedRowItemId || isLoading"
            @click="useAlternetPart">
            <i v-if="isLoading" class="fa fa-spinner fa-pulse fa-fw mr-1"></i>Use This Part
          </b-button>
        </div>
        <!-- <add-alternative @added="getAlternativesData" :alternativesIds="alternativesIds" :partId="partId"/> -->
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <!--:styleCustom="(itemData.length > 0) ? 'height: 160px' : ''"-->
        <grid-component
          isResizable
          isReorderable
          :canEdit="checkClaim(CAN_EDIT_INVENTORY)"
          :canDelete="checkClaim(CAN_DELETE_INVENTORY)"
          :gridId="gridId"
          :itemData="itemData"
          :fields="fields"
          :onDelete="onDelete"
          @checkedItem="checkedRowItemIds=$event"
          :handleRowClick="handleRowClick"
          :styleCustom="'height: 160px'"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import debounce from 'lodash/debounce';
import { mapGetters, mapActions, mapMutations } from 'vuex';
import { MODAL_ID,GRID_ID } from '@/shared/constants';
import { prepareColumnsData } from '@/shared/helpers';
import AddAlternative from './components/AddAlternative';
import GridSettings from '@/shared/components/GridSettings';
import AddRecord from '@/shared/components/AddRecord';
import addAlternativeFields from './components/AddAlternative/fields';
import GridComponent from '@/shared/components/GridComponent';
import PartForm from '@/pages/Parts/components/PartForm';
import fields from './fields';

export default {
  name: 'AlternativesTab',
  components: {
    AddAlternative,
    AddRecord,
    GridSettings,
    GridComponent,
    PartForm
  },
  props: {
    partId: [Number, String],
    gridId: [String],
    crfqLineId: [Number, String],
    quoteReplace: {
      type: Boolean,
      default: false
    },
    hideUseThis: {
      type: Boolean,
      default: false
    },
    statusId: {
      type: [Number, String],
      default: 0
    }
  },
  data() {
    return {
      prepareColumnsData,
      fields,
      addAlternativeFields,
      modalId: MODAL_ID.ALTERNATIVE_PARTS,
      showFilters: {
        alternativePart: true
      },
      filterValObj: {
        searchQuery: null
      },
      checkedAlternativePartIds: [],
      checkedRowItemIds: [],
      checkedRowItemsObjArr: [],
      addAlternativeGridId: GRID_ID.ALTERNATIVES_ADD_GRID,
      selectedRowItemId:0,
      alternativePartId:0,
      isLoading: false,
      statusApplicable: [133, 134, 135, 136, 326, 206, 440]
    }
  },
  watch: {
    partId: function() {
      this.getAlternativesData();
    },
  },
  computed: {
    ...mapGetters('inventoryDetails', ['partDetailsById']),
    ...mapGetters('alternatives', ['alternativesList', 'alternativesParts']),
    ...mapGetters('account', ['gridSettingsById']),
    gridSettings() {
      return this.gridSettingsById(this.gridId);
    },
    alternativesIds() {
      return this.alternativesList.map(part => part.alternativePartId);
    },
    partDetails() {
      return this.partDetailsById(this.partId)
    },
    itemData() {
      return this.alternativesList.map((alternative) => ({ ...alternative, selected: alternative.id === this.selectedRowItemId }));
    },
  },
  methods: {
    ...mapActions('alternatives', [
      'getAll',
      'deleteAlternative',
      'addToSources',
      'searchAlternatives',
      'saveAlternatives',
    ]),
    ...mapActions('requirements', ['replacePart']),
    ...mapActions('quotes', {'quoteReplacePart':'replacePart'}),
    ...mapActions('account', ['saveGridSettings']),
    ...mapMutations('alternatives', ['setItem']),
    async getAlternativesData() {
      if (this.partId) {
        await this.getAll(this.partId);
      } else {
        /*this.setAlternatives([]);*/
        this.setItem({resource: 'alternativesList', payload: []});
      }
    },
    async onPartCreated(e) {
      this.$bvModal.hide('add-new-part-alternative');
      this.checkedAlternativePartIds = [e.id];
      this.addAlternatives();
      this.filterValObj.searchQuery = e.partNumber;
      this.onSearch();
    },
    showAddModal() {
      this.$root.$emit('bv::show::modal', 'add-alternative-modal', '#btnShow');
    },
    async onDelete(alternative) {
      const deleteConfirmed = await this.openConfirmBox({message: `Are you sure you want to delete this alternative "${alternative.primartPartNumber}"?`});
      if (deleteConfirmed) {
        await this.deleteAlternative(alternative.id);
        await this.getAlternativesData();
      }
    },
    onSearch: debounce(async function() {
      const { partId, filterValObj: query, alternativesIds } = this;
      await this.searchAlternatives({
        partId,
        query,
        alternativesIds,
      });
    }, 500),
    addAlternatives: async function() {
      const { partId, checkedAlternativePartIds: alternatives } = this;
      await this.saveAlternatives({ partId, alternatives });
      await this.getAll(partId);
    },
    resetModal() {
      this.filterValObj.searchQuery = '';
      /*this.clearAlternativesParts();*/
      this.setItem({resource: 'alternativesParts', payload: []});
    },
    async useAlternetPart(){
      if(this.quoteReplace){
        try {
          this.isLoading = true;
          const data = await this.quoteReplacePart({
            quoteLineId: this.crfqLineId,
            partId: this.alternativePartId
          }).catch(() => {
            this.isLoading = false;
          });
          this.isLoading = false;
          if (data && data.id) {
            this.$emit('updatedQuote');
          }
        }catch (e) {
          this.isLoading = false;
          /*console.log(e.message);*/
        }
      }else{
        try {
          this.isLoading = true;
          const data = await this.replacePart({
            requirementLineId: this.crfqLineId,
            partId: this.alternativePartId
          }).catch(() => {
            this.isLoading = false;
          });
          this.isLoading = false;
          if (data && data.id) {
            this.$router.push({
              name: 'requirements.crfq',
              query: {crfqId: data.id, crfqLineId: data.lines[0].id, partId: data.lines[0].partId},
            });
          }
        }catch (e) {
          this.isLoading = false;
          /*console.log(e.message);*/
        }
      }

    },
    handleRowClick(row) {
      this.selectedRowItemId = row.dataItem.id;
      this.alternativePartId = row.dataItem.alternativePartId;
    },
  },
  mounted() {
    this.getAlternativesData();
  },
};
</script>

<style lang="scss">
.inventory--alternative-tab {
  .alternative-grid-header {
    margin-bottom: 5px;
  }
}
</style>
